import { ofType } from 'redux-observable';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import configurationSlice from './configurationSlice';
import getConfiguration$ from '../apis/getConfiguration';

const actions = configurationSlice.actions;

export default (action$) =>
  action$.pipe(
    ofType(actions.fetchConfiguration.type),
    switchMap(() =>
      getConfiguration$().pipe(
        mergeMap((response) => of(actions.fetchConfigurationFulfilled(response))),
        catchError((error) => of(actions.fetchConfigurationError(error.message)))
      )
    )
  );